<template>
  <div class="cate-box" :style="{ width }" @mouseleave="close()">
    <div class="cate-list" ref="cateBOX">
      <ul ref="cateUL">
        <li
        v-for="(item, index) of list"
        :key="index"
        @mouseenter.stop="open(index)"
        :ref="'cateitem' + index"
      >
        <a :href="'#/publicCourse?parentId=' + item.cateId">
          <div class="cate-item">
            <h3 class="cate-title">{{ item.cateName }}</h3>
            <div class="cate-content" v-if="item.courseSubList.length > 0">
              <span v-for="(item2, index2) of item.courseSubList" :key="index2">
                <template v-if="index2 < 1">
                  {{ item2.cateName }}
                  <!-- <label
                    v-if="
                      item2.cateName.length < 7 &&
                      index2 < item.courseSubList.length - 1
                    "
                    >/</label
                  >
                  <br v-else /> -->
                </template>
              </span>
            </div>
            <!-- <div class="cate-content" v-else>
              <span
                v-for="(item2, index2) of item.courseListList"
                :key="index2"
              >
                <template v-if="index2 < 2">
                  {{ item2.courseName }}
                  <label
                    v-if="
                      item2.courseName.length < 7 &&
                      index2 < item.courseListList.length - 1
                    "
                    >/</label
                  >
                  <br v-else />
                </template>
              </span>
            </div> -->
          </div>
        </a>
      </li>
      <li style="height:50px">
      </li>
      </ul>
    </div>
    <div class="bottom-tips" v-show="showTip">
      <i class="el-icon-arrow-down"></i> 鼠标下滑查看更多
    </div>
    <transition name="fade">
      <div class="cate-part" v-if="catePartShow">
        <h3>{{ curTitle }}</h3>
        <div v-if="partList.length > 0" class="cate-panel">
          <a
          :href="'#/publicCourse?parentId=' + curParentId+'&childId='+item.cateId"
            class=""
            v-for="(item, index) of partList"
            :key="index"
          >
            {{ item.cateName }}
          </a>
        </div>
        <el-empty v-else description="暂无数据"></el-empty>
      </div>
    </transition>
  </div>
</template>

<script>
import { deepClone } from "@/utils/index";
import {getCourseHomeList} from '@/apiCloud/CateSelect'
export default {
  props: {
    width: {
      type: String,
      default: "338px",
    },
  },
  data() {
    return {
      activeIndex: 0,
      catePartShow: false,
      list:[],
      curParentId:null,
      partList: [],
      curTitle: "",
      a: 0,
      courseType:'',
      showTip:false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取课程数据
    getList() {
      getCourseHomeList({ courseSource: 0, pageSize: 1000, pageNum: 1 }).then(
        (res) => {
          if (res.code==200) {
            res.data = res.data.sort(function (a, b) {
              // return b.courseListList.length - a.courseListList.length;
              return b.courseSubList.length - a.courseSubList.length;
            });
            this.list = res.data;
            this.$nextTick(()=>{
              if(this.$refs.cateUL.offsetHeight>this.$refs.cateBOX.offsetHeight){
                this.showTip = true;
              }
            })
          }
        }
      );
    },
    open(index) {
      this.activeIndex = index;
      // let data = this.list[index].courseListList;
      this.curParentId = this.list[index].cateId;
      let data = this.list[index].courseSubList;
      this.curTitle = this.list[index].cateName;
      if (Array.isArray(data) && data.length > 0) {
        this.partList = deepClone(data);
      } else {
        this.partList = [];
      }
      if(this.partList.length<1){
        this.close();
        return
      }
      this.catePartShow = true;
      this.$nextTick(() => {
        let top =
          this.$refs["cateitem" + index][0].offsetTop -
          $(".cate-box .cate-list").scrollTop();
        $(".cate-box .cate-part").css({
          top: top,
        });
      });
    },
    close() {
      this.catePartShow = false;
      this.partList = [];
      this.curParentId = null;
    },
    GotoCourseDetail(id, packagebagId) {
      this.$router.push({
        name: "courseDetail",
        params: {
          courseId: id,
          packagebagId,
          oldPage: 1,
          courseType: this.courseType,
        },
      });
      localStorage.setItem("packagebagId", packagebagId);
      localStorage.setItem("courseId", id);
      localStorage.setItem("courseType", this.courseType);
    },
  },
};
</script>

<style lang="less" scoped>
.cate-box {
  position: relative;
  background: #fff;
  .bottom-tips{
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 80px;
    background-image:linear-gradient(360deg,#fff 0%,#fff 38%, rgba(255,256,255,0.5) 75%,rgba(255,256,255,0.1) 60%);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #999;
    padding-top: 50px;
    box-sizing: border-box;
    i{
      display: block;
      border: 1px solid #999;
      border-radius: 50%;
      margin-right: 3px;
      font-size: 12px;
    }
  }
  .cate-list {
    // position: relative;
    // z-index: 6;
    // height: 628px;
    height: 100%;
    box-sizing: border-box;
    background: #fff;
    overflow-y: hidden;
    &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-thumb {
      background: #ddd;
      border-radius: 20px;
    }
    &:hover{
      overflow-y: auto;
    }
    
    .cate-item {
      padding: 9px 20px;
      box-sizing: border-box;
      transition: color 0.3s;
      .cate-title {
        font-weight: bold;
        color: #000;
        margin-bottom: 20px;
        font-size: 18px;
        background: url("../../../../static/home2.0/icon-cate.png") no-repeat
          center left;
        padding-left: 27px;
        box-sizing: border-box;
        transition: all 0.3s;
      }
      .cate-content {
        color: #666;
        font-size: 16px;
        padding-left: 27px;
        transition: all 0.3s;
      }
      &:hover {
        background: rgba(52, 130, 255, 0.1);
        border-left: 4px solid #3482ff;
        padding-left: 16px;
        .cate-title {
          color: #3482ff;
        }
        .cate-content {
          color: #3482ff;
        }
      }
    }
  }

  .cate-part {
    position: absolute;
    left: 100%;
    // top: 0;
    // top: 160px;
    // left: 50%;
    // margin-left: -262px;
    z-index: 20;
    // width: max-content;
    width: 650px;
    max-width:650px;
    min-height: 350px;
    max-height: 100%;
    padding: 10px 0 30px 0;
    padding-right: 0;
    padding-bottom: 30px;
    box-sizing: border-box;
    overflow-y: auto;
    background: #fff url(../../../../static/home2.0/cate-bg.png) no-repeat right bottom;
    box-shadow: 2px 2px 20px 0 #aaa;
    &.fade-enter-active,
    .fade-leave-active {
      transition: all 0.5s;
    }
    &.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
      opacity: 0;
      left: 47%;
    }

    h3 {
      font-weight: bold;
      color: #000;
      margin-bottom: 20px;
      margin-left: 10px;
      font-size: 18px;
      background: url("../../../../static/home2.0/icon-cate.png") no-repeat
        center left;
      padding-left: 27px;
      box-sizing: border-box;
      transition: all 0.3s;
    }
    .cate-panel {
      width: 100%;
      padding-right: 130px;
      box-sizing: border-box;
      max-height: 260px;
      color: #666;
      font-size: 16px;
      display: flex;
      // flex-direction: column;
      flex-wrap: wrap;
      overflow-y: auto;
      &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-thumb {
      background: #ddd;
      border-radius: 20px;
    }
      a {
        padding: 6px 15px;
        color: #666;
        &:hover {
          color: #3482ff;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/CateBox/src/main.vue